import { UniButton } from '@/design-system/components/buttons';
import { ButtonVariant } from '@/design-system/components/buttons/useButton.hook';
import { useDatePickerSelector } from '@/design-system/components/datePicker/useDatePickerSelector';
import { Calendar } from '@/design-system/components/dateRangePicker/Calendar';
import { BottomSheetHeader } from '@/design-system/components/headers';
import { DATE_FORMAT, formatDate } from '@/utils/dateFormatting';
import { SxProp, View } from 'dripsy';
import { Moment } from 'moment-timezone';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface DateFilterProps {
  dateProps: Moment | null;
  options?: {
    minDate?: Moment | null;
    maxDate?: Moment | null;
  };
  closeBottomSheet: () => void;
  onValueChange: (value: Moment | null) => void;
}

export const DateFilterPopup: React.FC<DateFilterProps> = ({ dateProps, options, closeBottomSheet, onValueChange }) => {
  const { t } = useTranslation('earn');
  const [selectedDate, setSelectedDate] = useState<Moment | null>(dateProps);
  const selector = useDatePickerSelector({ value: dateProps, onValueChange: () => {} });

  const onConfirm = () => {
    onValueChange(selectedDate);
    closeBottomSheet();
  };

  useEffect(() => {
    setSelectedDate(dateProps);
  }, [dateProps]);

  return (
    <View sx={sxStyles.body}>
      <BottomSheetHeader title={t('earn-invest::glossary.mobile-filter-date')} onPress={closeBottomSheet} />
      <View sx={sxStyles.dateButton}>
        <UniButton
          size="small"
          variant={!selectedDate ? ButtonVariant.outline1 : ButtonVariant.outline}
          label={
            selectedDate
              ? formatDate(selectedDate.toString(), { format: DATE_FORMAT.NO_TIME })
              : t('global-bill-payment::glossary.select-date')
          }
          onPress={() => undefined}
          wrapperSx={sxStyles.flex1}
        />
      </View>
      <View sx={{}}>
        <Calendar
          side="SINGLE"
          mode="DATE"
          selectedDate={selectedDate}
          selectedDateRange={{
            from: null,
            to: null
          }}
          calendar={selector.calendarLeft}
          onSelectDate={(date) => {
            if (!date) return;
            setSelectedDate(date);
          }}
          options={options}
          onPreviousMonth={selector.onPreviousMonth}
          onNextMonth={selector.onNextMonth}
          onPreviousYear={selector.onPreviousYear}
          onNextYear={selector.onNextYear}
        />
      </View>
      <View sx={sxStyles.footerButton}>
        <UniButton size="default" label={t('earn-invest::glossary.done')} onPress={onConfirm} />
      </View>
    </View>
  );
};

const sxStyles: Record<string, SxProp> = {
  body: {
    mb: '$13',
    paddingX: '$4',
    pb: '$4'
  },
  dateButton: {
    gap: '$3',
    mb: '$3',
    flexDirection: 'row',
    alignItems: 'center'
  },
  footerButton: {
    mt: '$4'
  },
  flex1: {
    flex: 1
  }
};
